import { useState } from "react";
import { ANGLES } from "@/lib/brand";

export function CarGallery({ car }) {
  const items = [
    ...ANGLES.map((a) => ({ ...a, src: car.images[a.key] })),
    ...(car.extra_images || []).map((src, i) => ({ key: `extra-${i}`, label: `Photo ${i + 6}`, short: `${i + 6}`, src })),
  ].filter((x) => x.src);
  const [active, setActive] = useState(items[0]?.key || "front");
  const current = items.find((x) => x.key === active) || items[0];
  if (!current) return null;
  return (
    <div className="space-y-4" data-testid="car-gallery">
      <div className="relative aspect-[3/2] overflow-hidden rounded-3xl bg-neutral-100">
        {items.map((x) => (
          <img key={x.key} src={x.src} alt={`${car.name} ${x.label}`} data-testid={`gallery-main-${x.key}`}
            className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-500 ${current.key === x.key ? "opacity-100" : "opacity-0"}`} />
        ))}
        <span className="absolute bottom-4 left-4 rounded-full bg-black/60 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.15em] text-white backdrop-blur" data-testid="gallery-active-label">
          {current.label}
        </span>
        <span className="absolute bottom-4 right-4 rounded-full bg-black/60 px-3 py-1.5 text-xs font-semibold text-white backdrop-blur" data-testid="gallery-count">
          {items.indexOf(current) + 1} / {items.length}
        </span>
      </div>
      <div className="flex gap-2 overflow-x-auto pb-1 sm:gap-3">
        {items.map((x) => (
          <button key={x.key} onClick={() => setActive(x.key)} data-testid={`gallery-tab-${x.key}`}
            className={`group w-[22%] min-w-[84px] shrink-0 overflow-hidden rounded-xl border-2 text-left transition-[border-color,transform] duration-200 hover:-translate-y-0.5 sm:w-[18%] ${current.key === x.key ? "border-[#FF5A00]" : "border-transparent"}`}>
            <img src={x.src} alt={x.label} className="aspect-[3/2] w-full object-cover" loading="lazy" />
            <span className={`block truncate px-1 py-1.5 text-center text-[10px] font-semibold sm:text-xs ${current.key === x.key ? "text-[#FF5A00]" : "text-neutral-600"}`}>
              <span className="sm:hidden">{x.short}</span><span className="hidden sm:inline">{x.label}</span>
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
